import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ErrorsComponent } from './errors/errors.component';
import { CabecalhoComponent } from './layout/cabecalho/cabecalho.component';
import { RodapeComponent } from './layout/rodape/rodape.component';
import { BarraComponent } from './layout/barra/barra.component';
import { HeaderPanelComponent } from './layout/header-panel/header-panel.component';

import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { DataViewModule } from 'primeng/dataview';
import { ChipModule } from 'primeng/chip';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { FieldsetModule } from 'primeng/fieldset';
import { CarouselModule } from 'primeng/carousel';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { RatingModule } from 'primeng/rating';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { ToastModule } from 'primeng/toast';

import { StaticFilePipe, TruncateTextPipe } from '@core/pipes';
import { ModalCuroIncricaoComponent } from './layout/modal-curo-incricao/modal-curo-incricao.component';
import { ModalPlanoInscricaoComponent } from './layout/modal-plano-inscricao/modal-plano-inscricao.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    AccordionModule,
    TabViewModule,
    DataViewModule,
    ButtonModule,
    TableModule,
    ChipModule,
    FieldsetModule,
    CarouselModule,
    TagModule,
    DialogModule,
    RatingModule,
    DropdownModule,
    CheckboxModule,
    PdfViewerModule,
    ToastModule,
  ],
  declarations: [
    CabecalhoComponent,
    RodapeComponent,
    BarraComponent,
    HeaderPanelComponent,
    ErrorsComponent,
    TruncateTextPipe,
    StaticFilePipe,
    ModalCuroIncricaoComponent,
    ModalPlanoInscricaoComponent,
  ],
  exports: [
    CabecalhoComponent,
    BarraComponent,
    HeaderPanelComponent,
    RodapeComponent,
    ErrorsComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    AccordionModule,
    TabViewModule,
    DataViewModule,
    ButtonModule,
    TableModule,
    ChipModule,
    FieldsetModule,
    CarouselModule,
    TagModule,
    DialogModule,
    TruncateTextPipe,
    StaticFilePipe,
    RatingModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,
    CheckboxModule,
    PdfViewerModule,
    ToastModule,
    ModalCuroIncricaoComponent,
    ModalPlanoInscricaoComponent,
  ],
})
export class SharedModule {}
